<template>
    <v-btn @click="onClick" flat> <v-icon left>chevron_left</v-icon>
        <slot>Back</slot>
    </v-btn>
</template>

<script>
export default {
    methods: {
        onClick() {
            this.$emit('click');
        }
    }
}
</script>